import { Navigate, useLocation } from 'react-router-dom';
import { useSession } from '@/hooks';
import { MoreLayout } from './MoreLayout';

export function MorePage() {
  const { isAuthenticated } = useSession();
  const location = useLocation();
  if (!isAuthenticated) {
    return <Navigate to={`/signin?next=${encodeURIComponent(location.pathname)}`} replace />;
  }
  return <MoreLayout />;
}
